import request from '@/utils/request'

/** 誠實態：FIXED_PLAYBOOK ≠ Brand Agent 對話發現 */
export function fetchSmartGuideHonestyStatus () {
  return request({
    url: '/coffee/leo/soc-smart-guide/honesty-status',
    method: 'get'
  })
}

export function fetchSmartGuidePlaybooks (guideRole) {
  const params = {}
  if (guideRole) params.guideRole = guideRole
  return request({
    url: '/coffee/leo/soc-smart-guide/playbooks',
    method: 'get',
    params: params
  })
}

export function fetchSmartGuideProcessNet () {
  return request({
    url: '/coffee/leo/soc-smart-guide/process-net',
    method: 'get'
  })
}

export function intakeProcessNet (payload) {
  return request({
    url: '/coffee/leo/soc-smart-guide/process-net/intake',
    method: 'post',
    data: payload || {}
  })
}

export function startSmartGuideSession (playbookId, opts) {
  const data = { playbookId: playbookId || 'store_manager_dispenser_r1' }
  if (opts && opts.storeId) data.storeId = opts.storeId
  if (opts && opts.entryStepId) data.entryStepId = opts.entryStepId
  if (opts && opts.pathHint) data.pathHint = opts.pathHint
  if (opts && opts.forceRestart) data.forceRestart = true
  if (opts && opts.produceId) data.produceId = opts.produceId
  if (opts && opts.refId) data.refId = opts.refId
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/start',
    method: 'post',
    data: data
  })
}

export function fetchSmartGuideCatalogGapReport (payload) {
  return request({
    url: '/coffee/leo/soc-smart-guide/catalog/gap-report',
    method: 'post',
    data: payload || {}
  })
}

export function fetchActiveSmartGuideSession () {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/active',
    method: 'get'
  })
}

export function fetchUnfinishedSmartGuideSessions () {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/unfinished',
    method: 'get'
  })
}

export function resumeSmartGuideSession (sessionId) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/resume',
    method: 'post'
  })
}

export function pauseSmartGuideSession (sessionId) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/pause',
    method: 'post'
  })
}

export function refreshSmartGuideSession (sessionId) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/refresh',
    method: 'post'
  })
}

export function cancelSmartGuideSession (sessionId) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/cancel',
    method: 'post'
  })
}

export function assistSmartGuideSession (sessionId, action) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/assist',
    method: 'post',
    data: { action: action || 'refresh_check' }
  })
}

export function fetchProcessNetInbox () {
  return request({
    url: '/coffee/leo/soc-smart-guide/process-net/inbox',
    method: 'get'
  })
}

export function fetchProcessNetNotices () {
  return request({
    url: '/coffee/leo/soc-smart-guide/process-net/notices',
    method: 'get'
  })
}

export function ackProcessNetNotice (id) {
  return request({
    url: '/coffee/leo/soc-smart-guide/process-net/notices/' + id + '/ack',
    method: 'post'
  })
}

export function fetchWorkOrderTogo (kind, refId, insertHint) {
  var params = { kind: kind || 'x600h_production', refId: refId }
  if (insertHint) params.insertHint = insertHint
  return request({
    url: '/coffee/leo/soc-smart-guide/work-order-togo',
    method: 'get',
    params: params
  })
}

export function fillSmartGuideSlots (sessionId, slots) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/slots',
    method: 'post',
    data: { slots: slots || {} }
  })
}




// WEBPACK FOOTER //
// ./src/api/socSmartGuide.js